import React from "react";

const ExportInvoice = ({subscription, taxMeta, countryCode = "AE"}) => {
  const distributorName = subscription?.directorCode || "Missing Distributor Name";
  const distributorCode = subscription?.directorCode || "Missing Distributor Code";
  const distributorCountry = subscription?.country || "Missing Country";

    return (
        <div className="text-white">

            <div className="text-lg font-bold text-cyan-400">
                EXPORT INVOICE
            </div>
            <div className="text-xs text-gray-400 mt-1">
                Export Of Services Under LUT
            </div>
            <div className="border-t border-gray-700 mt-4 pt-4">
                <div className="text-sm font-semibold text-cyan-300">
                    Supplier
                </div>
                <div className="text-xs mt-2">
                    {taxMeta.companyName}
                </div>
                <div className="text-xs">
                    {taxMeta.companyAddress}
                </div>
                <div className="text-xs">
                    GST: {taxMeta.GSTNo}
                </div>
                <div className="text-xs">
                    SAC: {taxMeta.HSNCode}
                </div>
            </div>
            <div className="border-t border-gray-700 mt-4 pt-4">
                <div className="text-sm font-semibold text-cyan-300">
                    Distributor
                </div>
                <div className="text-xs mt-2">
                    {distributorName }
                </div>
                <div className="text-xs">
                    {distributorCode}
                </div>
                <div className="text-xs">
                    Country: {distributorCountry}
                </div>
            </div>

            <div className="border-t border-gray-700 mt-4 pt-4">
                <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>Invoice No</div>
                    <div className="text-right">
                        {subscription.invoiceNumber}
                    </div>
                    <div>Invoice Date</div>
                    <div className="text-right">
                        {subscription.paymentDate
                            ? new Date(subscription.paymentDate).toLocaleDateString()
                            : "-"
                        }
                    </div>
                    <div>Subscription</div>
                    <div className="text-right">
                        {subscription.product}
                    </div>
                    <div>Export Value</div>
                    <div className="text-right text-green-400">
                        {subscription.currencySymbol}
                        {Number(subscription.baseAmount || 0).toFixed(2)}
                    </div>
                    <div>GST</div>
                    <div className="text-right">
                        0%
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExportInvoice;